import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
import type { ButtonGroupProps } from './ButtonGroup.types';

const ButtonGroup = ({
  onClickDelete,
  onClickNew,
  onClickCancel,
  onClickRegist,
  onClickConfirm,
  isNewClicked,
  cancelButtonState = false,
  confirmButtonState = false,
  deleteButtonState = false,
  newButtonState = false,
  showNew = true,
}: ButtonGroupProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full flex flex-row items-center overflow-hidden">
      <div className="flex w-full flex-row gap-[10px] h-full">
        <Button
          label={t('cmn > confirm')}
          customButton="btn-search h-[41px] text-[14px]!"
          disabled={confirmButtonState}
          onClick={onClickConfirm}
        />
        <Button
          label={t('cmn > cancel')}
          customButton="btn-danger h-[41px] text-[14px]!"
          disabled={cancelButtonState}
          onClick={onClickCancel}
        />
        <Button
          label={t('cmn > delete')}
          customButton="btn-danger h-[41px] text-[14px]!"
          disabled={deleteButtonState}
          onClick={onClickDelete}
        />
        {/* <Button label={"New"} customButton="btn-search" disabled={newButtonState} onClick={onClickNew} /> */}

        {showNew && !isNewClicked && (
          <Button
            label={t('cmn > new')}
            customButton="btn-search h-[41px] text-[14px]!"
            disabled={newButtonState}
            onClick={onClickNew}
          />
        )}

        {showNew && isNewClicked && (
          <Button
            label={t('cmn > register')}
            customButton="btn-search h-[41px] text-[14px]!"
            disabled={newButtonState}
            onClick={onClickRegist}
          />
        )}
      </div>
    </div>
  );
};

export default ButtonGroup;
